/**
 * One-line "why" on the first signup screen.
 *
 * Organic traffic is mixed — some are sending a gift, some are setting up a
 * registry — so the default line covers both. Gifting and invite arrivals get
 * a line that matches what they were already doing.
 */

const DEFAULT_VALUE_LINE =
    'Start saving for your child’s future, or gift a future for someone else.';

const GIFTING_VALUE_LINE =
    'Create an account, unlock lower fees.';

function invitedValueLine(inviterName, childName) {
    const inviter = inviterName || 'A friend';
    if (childName) {
        return `${inviter} invited you to gift toward ${childName}’s future.`;
    }
    return `${inviter} invited you to join Greatest Gift.`;
}

/**
 * @param {object} params
 * @param {string} params.source    - `source` query param (e.g. 'give-a-gift', 'pm')
 * @param {string} params.inviter   - `from` query param, when the link came from a person
 * @param {string} params.childName - `Gift_for` query param, when gifting to a known child
 * @returns {{ line: string }}
 */
export function getSignupValueProps({ source, inviter, childName } = {}) {
    if (inviter) {
        return { line: invitedValueLine(inviter, childName) };
    }
    if (source === 'give-a-gift' || source === 'pm' || source === 'monthly-matching') {
        return { line: GIFTING_VALUE_LINE };
    }
    return { line: DEFAULT_VALUE_LINE };
}
